"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tieTuNumber = _interopRequireDefault(require("@/api/activity/tieTuNumber.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'tieTuActList',
  props: {
    refresh: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.fetchList();
          this.$emit('update:refresh', false);
        }
      }
    }
  },
  emits: ['addAct', 'handleEdit', 'handleRecord', 'handleReward'],
  data: function data() {
    return {
      loading: false,
      times: [],
      searchForm: {
        keywords: '',
        status: null,
        startTime: '',
        endTime: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      qrDialogVisible: false,
      qrImage: '',
      qrObj: {}
    };
  },
  methods: {
    changeTime: function changeTime(e) {
      if (!e || e.length === 0) {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
        this.fetchList();
      } else {
        this.searchForm.startTime = e[0];
        this.searchForm.endTime = e[1];
      }
    },
    changeStatus: function changeStatus(id, status) {
      var _this = this;
      _tieTuNumber.default.changeActStatus({
        id: id,
        status: status
      }).then(function () {
        _this.$message.success('状态修改成功');
        _this.fetchList();
      }).catch(function () {
        _this.$message.error('状态修改失败');
      });
    },
    addAct: function addAct() {
      this.$emit('addAct');
    },
    handleEdit: function handleEdit(row) {
      this.$emit('handleEdit', row);
    },
    handleRecord: function handleRecord(row) {
      this.$emit('handleRecord', row);
    },
    handleReward: function handleReward(row) {
      this.$emit('handleReward', row);
    },
    formatDate: function formatDate(val) {
      if (!val) return '-';
      if (typeof val === 'string' && val.indexOf('T') < 0 && val.length >= 19) {
        return val.substring(0, 19);
      }
      var d = val instanceof Date ? val : new Date(val);
      if (isNaN(d.getTime())) return val;
      var pad = function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    },
    pagePath: function pagePath(row) {
      return '/packages/pages/texture/index?id=' + row.id;
    },
    copyPagePath: function copyPagePath(row) {
      var _this2 = this;
      var text = this.pagePath(row);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          _this2.$message.success('已复制：' + text);
        }).catch(function () {
          _this2.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },
    fallbackCopy: function fallbackCopy(text) {
      var input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('已复制：' + text);
    },
    showCode: function showCode(row) {
      var url = 'http://api.gagacafe.com/tietu/' + row.id;
      var size = 500;
      this.qrImage = "https://api.qrserver.com/v1/create-qr-code/?size=".concat(size, "x").concat(size, "&data=").concat(encodeURIComponent(url));
      this.qrObj = row;
      this.qrDialogVisible = true;
    },
    fetchList: function fetchList() {
      var _this3 = this;
      this.loading = true;
      _tieTuNumber.default.getActList(this.searchForm).then(function (res) {
        _this3.tableData = res.records || [];
        _this3.searchForm.total = res.total || 0;
      }).finally(function () {
        _this3.loading = false;
      });
    },
    handleSizeChange: function handleSizeChange(n) {
      this.searchForm.limit = n;
      this.searchForm.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(n) {
      this.searchForm.page = n;
      this.fetchList();
    }
  },
  mounted: function mounted() {
    this.fetchList();
  }
};